import { render, staticRenderFns } from "./AddGroupMemberDialog.vue?vue&type=template&id=406c5563&scoped=true&"
import script from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"
export * from "./AddGroupMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406c5563",
  null
  
)

export default component.exports